
    import * as React from 'react';

    const ArrowUp12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M5.623 2.144l-3.54 3.573-.533-.528L5.998.7l4.45 4.49-.533.527-3.542-3.573v9.089h-.75v-9.09z" /></svg>
        </div>
      );
    };

    ArrowUp12.displayName = 'ArrowUp12';

    export default ArrowUp12;
  